import React from "react";
import styles from "./ProgressBar.module.css";

interface ProgressBarProps {
  progress: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ progress }) => (
  <div className={styles.progressContainer}>
    <div className={styles.progressBar} style={{ width: `${progress}%` }} />
  </div>
);

export default ProgressBar;
